export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }

        return JSON.parse(serializedState);
    } catch (error) {
        return undefined;
    }
}

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify({
            agency: state.agency,
            authentication: state.authentication,
            cruises: state.cruises,
            itinerary: state.itinerary,
            payment: state.payment,
            preCruise: state.preCruise,
            store: state.store,
            tac: state.tac,
        });
        localStorage.setItem('state', serializedState);
    } catch (error) {
        //TODO - decide how to handle errors - if needed
    }
}

export const removeLocalStorageState = () => {
    try {
        localStorage.removeItem('state');
    } catch (error) {
        // TODO - decide if this needs to be handled
    }
}